import { SET_ACCOUNT_MANAGER } from '../action-types';

export const customerAccountManagerReducer = (
  state = {},
  action
) => {
  switch (action.type) {
    case SET_ACCOUNT_MANAGER: {
      return {
        ...action.payload
      };
    }
    default:
      return state;
  }
};
